import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';

// Services
import { SharedService } from '../../../layouts/shared-service';
import { AirportFboGeofenceClustersService } from '../../../services/airportfbogeofenceclusters.service';
import { AppDialogWrapperService } from 'src/app/ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

// Models
import { AirportFboGeoFenceGridViewmodel } from '../../../models/fbo-geofencing/airport-fbo-geo-fence-grid-viewmodel';

import { NgxUiLoaderService } from "ngx-ui-loader";
import { FboGeofencingDialogNewAirportComponent } from
    "../fbo-geofencing-dialog-new-airport/fbo-geofencing-dialog-new-airport.component";

@Component({
    selector: 'app-fbo-geofencing-home',
    styleUrls: ['./fbo-geofencing-home.component.scss'],
    templateUrl: './fbo-geofencing-home.component.html',
})
export class FboGeofencingHomeComponent implements OnInit {
    // Public Members
    public pageTitle = 'FBO Geofencing';
    public breadcrumb: any[];
    public fboGeofencingData: any[];
    public airportFboGeoFenceGridData: any[];
    public airportFboGeofenceGridItem: AirportFboGeoFenceGridViewmodel;
    public fboHomeLoaderName: string = 'fbo-home-loader';

    constructor(
        private sharedService: SharedService,
        private airportFboGeofenceService: AirportFboGeofenceClustersService,
        private ngxLoader: NgxUiLoaderService,
        private appDialogWrapperService: AppDialogWrapperService
    ) { }

    ngOnInit() {
        this.loadFbogeofencing();
        this.loadAirportsWithAntennaData();
    }

    public onEditAirportFboGeoFence(airportFboGeoFenceClusterViewModel: AirportFboGeoFenceGridViewmodel): void {
        this.airportFboGeofenceGridItem = airportFboGeoFenceClusterViewModel;
    }

    public onEditClosed(event: AirportFboGeoFenceGridViewmodel): void {
        this.airportFboGeofenceGridItem = null;
        this.loadAirportsWithAntennaData();
    }

    public onAddAirportFboGeoFence(): void {
        const dialogWrapper = this.appDialogWrapperService.open<AirportFboGeoFenceGridViewmodel>({
            title: 'Add Airport Geo-Fence',
            component: FboGeofencingDialogNewAirportComponent,
            width: '450px',
            data: { icao: '' }
        });

        dialogWrapper.afterClosed().subscribe((result: AirportFboGeoFenceGridViewmodel) => {
            if (!result)
                return;

            this.airportFboGeofenceService
                .getAirportForGeoFencingByAcukwikAirportId(result.acukwikAirportId)
                .subscribe((response: AirportFboGeoFenceGridViewmodel) => {
                    this.onEditAirportFboGeoFence(response);
                });
        });
    }

    private loadFbogeofencing() {
        this.airportFboGeofenceService
            .getAllClusters()
            .subscribe((data: any) => {
                this.fboGeofencingData = data;
            });
    }

    private loadAirportsWithAntennaData() {
        this.airportFboGeoFenceGridData = null;
        this.ngxLoader.startLoader(this.fboHomeLoaderName);
        this.airportFboGeofenceService
            .getAirportsWithAntennaData()
            .subscribe((data: any) => {
                this.airportFboGeoFenceGridData = data;
                this.ngxLoader.stopLoader(this.fboHomeLoaderName);
            });
    }
}
